module.exports = __webpack_public_path__ + "img/pic3.2af7273d.png";